import PropTypes from "prop-types"
import React from "react"

import Tooltip from "src/components/Tooltip"

export const DOCKWA_ACCOUNT_TOOLTIP = {
  linked:
    "This boater has connected their Dockwa account. They can manage payments and sign contracts, and they're responsible for updating their insurance, account and boat information.",
  linkIssue:
    "This customer's email doesn't match the email on their linked Dockwa account. This may cause issues downstream, so we recommend fixing it in Customer Details before sending contracts, reservations or invoices.",
  notLinked:
    "This boater hasn't connected their Dockwa account. You will need to manage payments, insurance and boat information for them. Ask them to connect a Dockwa account if you'd rather they manage this themselves.",
}

const STATES = {
  linked: { icon: "fa-link text-teal-500", label: "Linked" },
  linkIssue: {
    icon: "fa-triangle-exclamation text-yellow-600",
    label: "Link Issue",
  },
  notLinked: { icon: "fa-link-slash text-gray-600", label: "Not linked" },
}

const resolveState = (linked, linkIssue) => {
  if (!linked) return "notLinked"
  return linkIssue ? "linkIssue" : "linked"
}

const DockwaAccountIndicator = ({
  linked,
  linkIssue = false,
  tooltip = false,
}) => {
  const state = resolveState(linked, linkIssue)
  const content = (
    <span className="inline-flex items-center gap-1">
      <i className={`fa-solid ${STATES[state].icon}`} />
      <span>{STATES[state].label}</span>
    </span>
  )

  if (!tooltip) return content

  return (
    <Tooltip
      text={DOCKWA_ACCOUNT_TOOLTIP[state]}
      placement="top"
      variant="dark"
      maxWidth="320px"
    >
      {content}
    </Tooltip>
  )
}

DockwaAccountIndicator.propTypes = {
  linked: PropTypes.bool.isRequired,
  linkIssue: PropTypes.bool,
  tooltip: PropTypes.bool,
}

export default DockwaAccountIndicator
